import React from 'react';
import logo from '../../../assets/images/topaz-logo.svg';

const Logo = props => {
    return <img src={logo} alt='topaz-logo' {...props} />;
};

export default Logo;
